import { render, staticRenderFns } from "./EmploymentInfo.vue?vue&type=template&id=673ed376&scoped=true&"
import script from "./EmploymentInfo.vue?vue&type=script&lang=js&"
export * from "./EmploymentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673ed376",
  null
  
)

export default component.exports